import type { Active } from '@dnd-kit/core';

// Drag types mirror the previous drag-and-drop library's droppable `type`s: sections
// only reorder among sections, and questions only among the questions of the
// section they belong to.
export const SECTION_DRAG_TYPE = 'section';
export const ITEM_DRAG_TYPE = 'item';

export const SECTION_SORTABLE_CONTAINER_ID = 'section-droppable';

export const getItemSortableContainerId = (sectionId: string) =>
  `section-items-${sectionId}`;

export const getItemSortableId = (
  itemId: string,
  sectionIndex: number | undefined,
) => `${itemId}~~${sectionIndex}`;

/** Section headers only accept a dragged section. */
export const isSectionDropDisabled = (active: Active | null) =>
  active !== null && active.data.current?.type !== SECTION_DRAG_TYPE;

/** Questions only accept a dragged question from the same section. */
export const isItemDropDisabled = (active: Active | null, sectionId: string) =>
  active !== null &&
  !(
    active.data.current?.type === ITEM_DRAG_TYPE &&
    active.data.current?.sectionId === sectionId
  );
